module.exports = __webpack_public_path__ + "static/lawn-3536217466e192e28d5fab234adf65e8.jpg";